(function () {
    angular.module('profile', [

    ]);
})();
